import { render, staticRenderFns } from "./ButtonCom.vue?vue&type=template&id=0e995c5c&"
import script from "./ButtonCom.vue?vue&type=script&lang=ts&"
export * from "./ButtonCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports